export enum UrlParameters {
  FARM_ID = ':farmId',
}
